<template>
  <div
    class="order-action-surface"
    v-if="
      (Object.keys(order_detail).length === 0 &&
        order_detail.constructor === Object) ||
      fetching_data == true
    "
  >
    <v-toolbar color="white" dense flat>
      <v-btn
        icon
        @click="backToList()"
        style="position: absolute; left: 10px; top: 0px"
      >
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-spacer />
      <v-progress-circular
        :size="30"
        :width="5"
        color="primary"
        indeterminate
        class="ma-3"
      ></v-progress-circular>
      Loading...
      <v-spacer />
    </v-toolbar>
  </div>
  <div v-else class="order-action-surface">
    <v-toolbar dense flat dark color="rgba(24, 28, 36, .92)">
      <v-btn
        icon
        @click="backToList()"
        style="position: absolute; left: 10px; top: 0px"
      >
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-spacer />
      <v-toolbar-title
        >Detail messenger order #{{ order_detail.order_code }}</v-toolbar-title
      >
      <v-spacer />
    </v-toolbar>
    <v-card flat class="messenger-actions-panel">
      <v-card-text class="messenger-actions-panel__body">
        <div class="messenger-actions-panel__buttons">
          <v-btn
            round
            color="primary"
            class="black--text messenger-action-btn"
            @click="dialogToggle('store')"
          >
            <v-icon left small color="black">store</v-icon>
            <span>Store chat room</span>
          </v-btn>
          <v-btn
            round
            color="primary"
            class="black--text messenger-action-btn"
            @click="dialogToggle('order')"
          >
            <v-icon left small color="black">forum</v-icon>
            <span>Order chat room</span>
          </v-btn>
          <v-tooltip top v-if="showChangeToCOD">
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                round
                class="change-cod-btn messenger-action-btn"
                :loading="codLoading"
                :disabled="codLoading"
                @click="handleChangeToCOD"
                color="primary"
              >
                <v-icon left small color="black">attach_money</v-icon>
                <span class="black--text">Change to COD</span>
              </v-btn>
            </template>
            <span>Change payment type to Cash on Delivery</span>
          </v-tooltip>
          <v-btn
            round
            dark
            color="red"
            class="messenger-action-btn messenger-action-btn--danger"
            @click="toCancelOrder()"
            :loading="canceling_order"
            :disabled="
              canceling_order ||
              (order_status_id == 6 &&
                $store.state.permission.order.edit_view != 3) ||
              (order_status_id == 7 &&
                $store.state.permission.order.edit_view != 3) ||
              (order_detail.order_status == 7 &&
                $store.state.permission.order.edit_view != 3) ||
              isEditOrder ||
              $route.name == 'OrderDetailMessenger'
            "
          >
            <v-icon left small>cancel</v-icon>
            <span>Cancel order</span>
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
    <order-incentive-dialog
      :order-id="order_detail.order_id"
      :order-code="order_detail.order_code"
      :province="incentiveProvince"
      :order-status="order_detail.order_status"
      :value="order_detail.order_incentive"
      :button="false"
      @saved="$set(order_detail, 'order_incentive', $event)"
    />
    <v-card
      v-if="shouldShowDispatchTimeline || showDispatchAction"
      class="dispatch-timeline-toolbar-card order-section-card mb-3"
      flat
    >
      <v-card-text class="py-3">
        <div class="dispatch-timeline-heading">
          <div class="dispatch-timeline-toolbar-title">Dispatch Timeline</div>
          <v-btn
            v-if="showDispatchAction"
            round
            color="primary"
            class="black--text dispatch-retry-glass-btn"
            :loading="dispatchButtonLoading"
            :disabled="dispatchRetryDisabled"
            @click="openDispatchPreview('retry')"
          >
            <v-icon left small color="black">refresh</v-icon>
            <span>{{ dispatchActionLabel }}</span>
          </v-btn>
        </div>
        <div v-if="dispatchStatusText" class="dispatch-status-text">
          {{ dispatchStatusText }}
        </div>

        <div v-if="dispatchCandidateNamesText" class="dispatch-status-subtext">
          {{ dispatchCandidateNamesText }}
        </div>
        <div class="hidden-sm-and-down dispatch-timeline-horizontal">
          <div
            v-for="(step, index) in dispatchTimeline"
            :key="`desktop-${index}`"
            class="dispatch-timeline-horizontal-item dispatch-timeline-step"
            :class="{ 'dispatch-timeline-step-active': step.color !== 'grey' }"
            :style="{ '--dispatch-step-delay': `${index * 90}ms` }"
          >
            <v-icon small :color="step.color">fiber_manual_record</v-icon>
            <span class="dispatch-timeline-horizontal-text">{{
              step.label
            }}</span>
            <div
              v-if="index < dispatchTimeline.length - 1"
              class="dispatch-timeline-horizontal-line"
            ></div>
          </div>
        </div>
        <div class="dispatch-timeline-vertical hidden-md-and-up">
          <div
            v-for="(step, index) in dispatchTimeline"
            :key="`mobile-${index}`"
            class="dispatch-timeline-item dispatch-timeline-step"
            :class="{ 'dispatch-timeline-step-active': step.color !== 'grey' }"
            :style="{ '--dispatch-step-delay': `${index * 90}ms` }"
          >
            <v-icon small :color="step.color">fiber_manual_record</v-icon>
            <span class="dispatch-timeline-text">{{ step.label }}</span>
            <div
              v-if="index < dispatchTimeline.length - 1"
              class="dispatch-timeline-line"
            ></div>
          </div>
        </div>
      </v-card-text>
    </v-card>
    <v-card flat class="mb-3 order-section-card">
      <v-layout row wrap>
        <v-flex xs12 sm6>
          <v-card-text>
            <strong style="font-size: 18px">Order Information</strong>
            <!-- <v-layout row>
              <v-flex xs6 class="mr-2">
                <v-text-field
                  :disabled="order_status_id == 6 || order_status_id == 7"
                  v-model="order_detail.order_code"
                  readonly
                  hide-details
                  label="Order code"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 class="ml-2">
                <v-text-field
                  :disabled="order_status_id == 6 || order_status_id == 7"
                  v-model="order_detail.order_amount_point"
                  readonly
                  hide-details
                  label="Position amount"
                ></v-text-field>
              </v-flex>
            </v-layout>-->
            <v-layout row>
              <v-flex xs6 class="mr-2">
                <div
                  class="text-xs-left"
                  v-if="
                    (order_status_id == 6 &&
                      $store.state.permission.order.edit_view != 3) ||
                    (order_status_id == 7 &&
                      $store.state.permission.order.edit_view != 3) ||
                    isEditOrder
                  "
                >
                  <label class="field-disable-title">Order coming date</label>
                  <br />
                  <div class="field-disable-data">
                    {{ order_detail.order_time_start.substring(0, 10) }}
                  </div>
                </div>
                <div class="text-xs-left" v-else>
                  <v-menu
                    :close-on-content-click="false"
                    v-model="start_date_menu"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                    class="mt-1"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="start_date"
                      label="Order start date: "
                      readonly
                      hide-details
                    ></v-text-field>
                    <v-date-picker
                      :min="moment().format('YYYY-MM-DD')"
                      v-model="start_date"
                      color="#333"
                      no-title
                      @input="start_date_menu = false"
                    ></v-date-picker>
                  </v-menu>
                </div>
              </v-flex>
              <v-flex xs6 class="ml-2 text-xs-left">
                <div
                  class="text-xs-left"
                  v-if="
                    (order_status_id == 6 &&
                      $store.state.permission.order.edit_view != 3) ||
                    (order_status_id == 7 &&
                      $store.state.permission.order.edit_view != 3) ||
                    isEditOrder
                  "
                >
                  <label class="field-disable-title">Order start time</label>
                  <br />
                  <div class="field-disable-data">
                    {{ order_detail.order_time_start.substring(11, 16) }}
                  </div>
                </div>
                <div
                  class="text-xs-left"
                  v-else
                  style="position: relative; border-bottom: 1px solid #757575"
                >
                  <span style="font-size: 12px; color: grey"
                    >Order start time</span
                  >
                  <vue-timepicker
                    hide-clear-button
                    format="HH:mm"
                    v-model="start_time"
                    style="width: 262px"
                  >
                  </vue-timepicker>
                </div>
              </v-flex>
            </v-layout>
            <!-- <v-layout row>
              <v-flex xs6 class="mr-2">
                <v-text-field
                  v-if="order_status_id == 6 || order_status_id == 7"
                  v-model="start_date"
                  label="Transfer date"
                  readonly
                  hide-details
                ></v-text-field>
                <v-menu
                  :close-on-content-click="false"
                  v-model="menu2"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  v-if="start_date != null && order_status_id != 6 && order_status_id != 7"
                >
                  <v-text-field
                    slot="activator"
                    v-model="start_date"
                    label="Transfer date"
                    readonly
                    hide-details
                  ></v-text-field>
                  <v-date-picker v-model="start_date" color="#333" no-title @input="menu2 = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex
                xs6
                class="ml-2 text-xs-left"
                style="position:relative;border-bottom:1px solid #757575"
              >
                <span class="title-after-input-data">Transfer time</span>
                <v-text-field
                  readonly
                  :value="order_detail.order_time_end.substring(11,16)"
                  hide-details
                  v-if="order_status_id == 6 || order_status_id == 7"
                ></v-text-field>
                <vue-timepicker
                  v-if="order_status_id != 6 && order_status_id != 7  && Object.keys(start_time).length != 0 && start_time.constructor === Object"
                  format="HH:mm"
                  class="forn-timepicker"
                  v-model="start_time"
                  style="top:17px;position:absolute;left:-7px;width:262px;"
                ></vue-timepicker>
              </v-flex>
            </v-layout>-->
            <v-layout row>
              <v-flex xs6 class="mr-2">
                <v-text-field
                  v-if="
                    (order_status_id == 6 &&
                      $store.state.permission.order.edit_view != 3) ||
                    (order_status_id == 7 &&
                      $store.state.permission.order.edit_view != 3) ||
                    isEditOrder
                  "
                  v-model="end_date"
                  :disabled="isEditOrder"
                  label="Transfer date"
                  readonly
                  hide-details
                >
                </v-text-field>
                <!-- <div class="text-xs-left" v-if="order_status_id == 6 || order_status_id == 7">
                  <label class="field-disable-title">Transfer date</label>
                  <br>
                  <div class="field-disable-data">{{end_date}}sss</div>
                </div>-->
                <v-menu
                  :close-on-content-click="false"
                  v-model="menu2"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  v-if="
                    end_date != null &&
                    order_status_id != 6 &&
                    order_status_id != 7 &&
                    !isEditOrder
                  "
                >
                  <v-text-field
                    slot="activator"
                    v-model="end_date"
                    label="Transfer date"
                    readonly
                    hide-details
                  >
                  </v-text-field>
                  <v-date-picker
                    :min="moment().format('YYYY-MM-DD')"
                    v-model="end_date"
                    color="#333"
                    no-title
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex
                xs6
                class="ml-2 text-xs-left"
                style="position: relative; border-bottom: 1px solid #757575"
              >
                <span class="title-after-input-data">Transfer time</span>
                <v-text-field
                  readonly
                  :value="order_detail.order_time_end.substring(11, 16)"
                  hide-details
                  :disabled="isEditOrder"
                  v-if="
                    (order_status_id == 6 &&
                      $store.state.permission.order.edit_view != 3) ||
                    (order_status_id == 7 &&
                      $store.state.permission.order.edit_view != 3) ||
                    isEditOrder
                  "
                ></v-text-field>
                <vue-timepicker
                  v-if="
                    order_status_id != 6 &&
                    order_status_id != 7 &&
                    Object.keys(end_time).length != 0 &&
                    end_time.constructor === Object &&
                    !isEditOrder
                  "
                  format="HH:mm"
                  class="forn-timepicker"
                  v-model="end_time"
                  style="
                    top: 17px;
                    position: absolute;
                    left: -7px;
                    width: 262px;
                  "
                ></vue-timepicker>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs6 class="mr-2">
                <v-select
                  :class="
                    (order_status_id == 6 &&
                      $store.state.permission.order.edit_view != 3) ||
                    (order_status_id == 7 &&
                      $store.state.permission.order.edit_view != 3)
                      ? 'hidden-disable'
                      : ''
                  "
                  :disabled="
                    (order_status_id == 6 &&
                      $store.state.permission.order.edit_view != 3) ||
                    (order_status_id == 7 &&
                      $store.state.permission.order.edit_view != 3) ||
                    isEditOrder
                  "
                  :items="status"
                  item-text="name"
                  item-value="value"
                  v-model="order_detail.order_status"
                  hide-details
                  label="Status"
                ></v-select>
              </v-flex>
              <v-flex xs6 class="ml-2">
                <v-select
                  class="hidden-disable"
                  :items="vehicle_list"
                  :disabled="true"
                  item-text="vehicle_title_th"
                  item-value="vehicle_id"
                  :loading="vehicle_list.length == 0 ? 'yellow' : false"
                  v-model="order_detail.order_vehicle_type"
                  hide-details
                  label="Vehicle type"
                ></v-select>
                <!-- <div class="text-xs-left">
                  <label class="field-disable-title">Vehicle type</label>
                  <br>
                  <div class="field-disable-data">{{order_detail.order_vehicle_type}} {{vehicle_list[0].vehicle_title_th}}</div>
                </div>-->
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs6 class="mr-2">
                <!-- "order_status_id == 6 || order_status_id == 7" -->
                <!-- <v-select
                  disabled
                  :items="pay"
                  item-text="name"
                  item-value="value"
                  v-model="order_detail.order_payment_type"
                  hide-details
                  label="COD"
                ></v-select>-->
                <div class="text-xs-left">
                  <label class="field-disable-title">COD</label>
                  <br />
                  <div class="field-disable-data">
                    {{
                      order_detail.order_payment_type == 1
                        ? "Cash"
                        : order_detail.order_payment_type == 2
                        ? "Credit card"
                        : order_detail.order_payment_type == 3
                        ? "PromptPay"
                        : order_detail.order_payment_type == 4
                        ? "Cryptocurrency"
                        : order_detail.order_payment_type == 5
                        ? "AR"
                        : ""
                    }}
                  </div>
                </div>
              </v-flex>
              <v-flex xs6 class="ml-2">
                <!-- <v-select
                  disabled
                  :items="pay_status"
                  item-text="name"
                  item-value="value"
                  v-model="order_detail.order_is_paymented"
                  hide-details
                  label="Pay status"
                ></v-select>-->
                <div class="text-xs-left">
                  <label class="field-disable-title">Pay status</label>
                  <br />
                  <div class="field-disable-data">
                    {{
                      order_detail.order_is_paymented == 1
                        ? "Not pay"
                        : order_detail.order_is_paymented == 2
                        ? "Paid"
                        : ""
                    }}
                  </div>
                </div>
              </v-flex>
            </v-layout>
            <v-select
              class="hidden-disable-addon"
              :disabled="
                (order_status_id == 6 &&
                  $store.state.permission.order.edit_view != 3) ||
                (order_status_id == 7 &&
                  $store.state.permission.order.edit_view != 3) ||
                isEditOrder
              "
              :loading="add_on_list.length == 0 ? 'yellow' : false"
              v-model="order_detail.order_addon"
              :items="add_on_list"
              item-text="addon_title_th"
              item-value="addon_type_id"
              attach
              chips
              color="black"
              label="Add on"
              multiple
              hide-details
            ></v-select>
            <v-textarea
              v-if="
                order_status_id != 6 && order_status_id != 7 && !isEditOrder
              "
              :disabled="
                (order_status_id == 6 &&
                  $store.state.permission.order.edit_view != 3) ||
                (order_status_id == 7 &&
                  $store.state.permission.order.edit_view != 3) ||
                isEditOrder
              "
              v-model="order_detail.order_transfer_note"
              hide-details
              rows="2"
              label="Note to rider :"
            ></v-textarea>
            <div
              class="text-xs-left mt-2"
              v-if="
                (order_status_id == 6 &&
                  $store.state.permission.order.edit_view != 3) ||
                (order_status_id == 7 &&
                  $store.state.permission.order.edit_view != 3) ||
                isEditOrder
              "
            >
              <label class="field-disable-title">Note to rider :</label>
              <br />
              <div class="field-disable-data">
                {{ order_detail.order_transfer_note }}
              </div>
            </div>
            <v-textarea
              v-model="order_detail.order_note"
              hide-details
              :disabled="isEditOrder"
              rows="2"
              label="Admin note :"
            ></v-textarea>
            <!-- <div class="text-xs-left mt-3" v-if="order_status_id == 7">
              <label class="field-disable-title">Admin note :</label>
              <br>
              <div class="field-disable-data">{{order_detail.order_note}}</div>
            </div>-->
          </v-card-text>
        </v-flex>
        <v-flex xs12 sm6>
          <v-card-text>
            <div class="pb-4">
              <strong style="font-size: 18px">Customer Information</strong>
              <v-card flat class="text-xs-left mt-2" color="#EEEEEE">
                <v-card-text style="font-size: 15px">
                  <span>
                    Name :
                    {{
                      order_detail.order_customer_full_name ||
                      order_detail.order_business_full_name
                    }}
                    <span style="color: #ababab">|</span>
                    {{ order_detail.order_customer_country_tel || ""
                    }}{{
                      order_detail.order_customer_tel ||
                      "0" + order_detail.order_business_tel
                    }}
                    <span style="color: #ababab">|</span>
                    {{
                      order_detail.order_customer_email ||
                      order_detail.order_business_email
                    }}
                  </span>
                </v-card-text>
              </v-card>

              <div class="mt-3">
                <div style="font-size: 18px; font-weight: bold">
                  Destination Information ({{ order_detail.order_amount_point }}
                  position)
                </div>
                <v-btn
                  small
                  color="primary"
                  class="black--text"
                  @click="expand = !expand"
                  >Show all detail</v-btn
                >
                <div
                  v-for="(place_info, place_index) in order_detail.order_point"
                  :key="place_info.order_point_id"
                >
                  <v-list class="pb-0">
                    <v-card>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <v-icon>place</v-icon>
                            {{ place_index + 1 }} :
                            {{ place_info.order_point_address }}
                          </v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action
                          style="position: absolute; right: 40px"
                        >
                          <v-tooltip top>
                            <v-icon
                              slot="activator"
                              :color="
                                place_info.order_point_status == 1
                                  ? 'green'
                                  : 'grey '
                              "
                              >{{
                                place_info.order_point_status == 1
                                  ? "check_circle"
                                  : "schedule"
                              }}</v-icon
                            >
                            <span>Status</span>
                          </v-tooltip>
                        </v-list-tile-action>
                        <v-list-tile-action>
                          <v-tooltip top>
                            <v-icon
                              slot="activator"
                              :color="
                                place_info.order_point_status == 1
                                  ? 'green'
                                  : 'grey '
                              "
                              @click="viewIMG(place_info)"
                              >image</v-icon
                            >
                            <span>View image</span>
                          </v-tooltip>
                        </v-list-tile-action>
                      </v-list-tile>
                    </v-card>
                  </v-list>
                  <imageDialog
                    :place_name="place_name"
                    :view_img_position="view_img_position"
                    :dialog="imageDialog"
                    @dialog="imageDialog = $event"
                  />
                  <v-scale-transition>
                    <v-card v-show="expand">
                      <v-card-text class="px-5 pt-1 grey lighten-3">
                        <v-layout row>
                          <v-flex xs12 class="mr-2">
                            <v-text-field
                              :disabled="
                                (order_status_id == 6 &&
                                  $store.state.permission.order.edit_view !=
                                    3) ||
                                (order_status_id == 7 &&
                                  $store.state.permission.order.edit_view !=
                                    3) ||
                                isEditOrder ||
                                $route.name == 'OrderDetailMessenger'
                              "
                              v-model="place_info.order_point_to"
                              hide-details
                              label="Full name"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs12 class="mr-2">
                            <v-text-field
                              hide-details
                              :disabled="
                                (order_status_id == 6 &&
                                  $store.state.permission.order.edit_view !=
                                    3) ||
                                (order_status_id == 7 &&
                                  $store.state.permission.order.edit_view !=
                                    3) ||
                                isEditOrder ||
                                $route.name == 'OrderDetailMessenger'
                              "
                              v-model="place_info.order_point_list_tel"
                              label="Tel"
                            >
                            </v-text-field>
                          </v-flex>
                        </v-layout>
                        <!-- <v-text-field
                          hide-details
                          :disabled="order_status_id == 6 || order_status_id == 7"
                          v-model="place_info.order_point_email"
                          label="E-mail "
                        ></v-text-field>-->
                        <v-textarea
                          :disabled="
                            (order_status_id == 6 &&
                              $store.state.permission.order.edit_view != 3) ||
                            (order_status_id == 7 &&
                              $store.state.permission.order.edit_view != 3) ||
                            isEditOrder ||
                            $route.name == 'OrderDetailMessenger'
                          "
                          name="address"
                          v-model="place_info.order_point_remark"
                          hide-details
                          label="Note : "
                          value
                          rows="2"
                        ></v-textarea>
                      </v-card-text>
                    </v-card>
                  </v-scale-transition>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-flex>
      </v-layout>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-layout column>
          <v-flex>
            <v-btn
              block
              round
              color="primary"
              class="black--text"
              :disabled="update_btn || update_loading == 1 || isEditOrder"
              @click="updateData()"
              >UPDATE</v-btn
            >
          </v-flex>
          <v-flex>
            <div transition="fade">
              <v-icon color="green" v-if="update_loading == 2">check</v-icon>
              <v-icon color="red" v-if="update_loading == 3">close</v-icon>
              <v-progress-circular
                :width="3"
                :size="15"
                indeterminate
                color="grey"
                v-if="update_loading == 1"
              >
              </v-progress-circular>
              {{
                update_loading == 1
                  ? "Updating"
                  : update_loading == 2
                  ? "Update successfully"
                  : update_loading == 3
                  ? "Cant update"
                  : null
              }}
            </div>
          </v-flex>
        </v-layout>
        <v-spacer />
      </v-card-actions>
      <v-divider />
      <div style="font-size: 18px; font-weight: bold" class="pt-3">
        Map Destination
      </div>

      <v-card-text style="display: flex; justify-content: center; width: 100%">
        <v-card height="auto" width="100%" color="white">
          <GoogleMap
            :directionRoute="directionRoute"
            :multiplePosition="positionLating()"
            :height="350"
            :zoom="12"
            :mapType="'direction'"
            :latitude="Number(order_detail.order_point[0].order_point_lat)"
            :longitude="Number(order_detail.order_point[0].order_point_long)"
            v-if="
              order_detail.order_point && order_detail.order_point.length > 0
            "
          ></GoogleMap>
        </v-card>
      </v-card-text>
    </v-card>

    <v-card flat class="mt-3 order-section-card">
      <div style="font-size: 18px; font-weight: bold" class="pt-3">
        Price Information
      </div>
      <v-layout row wrap align-end justify-center>
        <v-flex xs12 sm7>
          <v-card-text>
            <!-- <strong style="font-size: 18px;">Price Information</strong> -->
            <v-layout row justify-end align-end>
              <v-flex>
                <table
                  style="font-size: 16px; padding: 0 0 10px 20px"
                  width="90%"
                >
                  <tr>
                    <td
                      class="text-xs-left"
                      style="color: orange; font-weight: bold"
                    >
                      ระยะทางรวม
                    </td>
                    <td
                      class="text-xs-right"
                      style="color: orange; font-weight: bold"
                    >
                      {{
                        order_detail.order_point.reduce(
                          (a, b) =>
                            parseFloat(a.order_point_distance) ||
                            0 + parseFloat(b.order_point_distance) ||
                            0,
                          0
                        )
                      }}
                      km
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">Transportation :</td>
                    <td class="text-xs-right">
                      {{ order_detail.order_transfer_price }} THB
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">Add on :</td>
                    <td class="text-xs-right">
                      {{ order_detail.order_total_addon_price }} THB
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">Extra point :</td>
                    <td class="text-xs-right">
                      {{ order_detail.order_store_extra_price }} THB
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left" style="color: red">Discount :</td>
                    <td class="text-xs-right" style="color: red">
                      {{ order_detail.order_total_discount_price }} THB
                    </td>
                  </tr>
                  <tr>
                    <td
                      class="text-xs-left"
                      style="color: green; font-weight: bold"
                    >
                      Total price :
                    </td>
                    <td
                      class="text-xs-right"
                      style="color: green; font-weight: bold"
                    >
                      {{ order_detail.order_net_price }} THB
                    </td>
                  </tr>
                </table>

                <!-- <v-divider/>
                <table style="padding:0 16px;" width="100%">
                  <tr>
                    <td class="text-xs-right green--text">
                      <strong>{{ order_detail.order_net_price }} ฿</strong>
                    </td>
                  </tr>
                </table>-->
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-flex>

        <v-flex xs9 sm6>
          <v-layout row wrap>
            <v-flex xs9>
              <v-text-field
                hide-details
                class="ml-3"
                solo
                v-model="use_promo_code"
                label="Promotion code"
                :disabled="
                  order_status_id != 1 ||
                  order_detail.order_resend_order.length != 0 ||
                  isEditOrder ||
                  $route.name == 'OrderDetailMessenger'
                "
              ></v-text-field>
            </v-flex>
            <v-flex xs3>
              <v-btn
                @click="usePromotion()"
                style="margin-bottom: 39px"
                :loading="using_promo_code"
                :disabled="
                  order_status_id != 1 ||
                  order_detail.order_resend_order.length != 0 ||
                  isEditOrder ||
                  $route.name == 'OrderDetailMessenger'
                "
                >add</v-btn
              >
            </v-flex>
          </v-layout>
          <v-card class="mb-3">
            <v-layout row wrap align-center>
              <v-flex xs9>
                <div
                  style="
                    color: grey;
                    padding: 10px 0 10px 20px;
                    text-align: left;
                    font-size: 16px;
                  "
                  v-if="
                    order_detail.order_discount == null &&
                    order_detail.order_discount_code != null
                  "
                >
                  Recent promotion : {{ order_detail.order_discount_code }}
                </div>
                <div
                  style="
                    padding: 10px 0 10px 20px;
                    text-align: left;
                    font-size: 16px;
                  "
                  v-if="
                    order_detail.order_discount != null &&
                    order_detail.order_discount_code != null
                  "
                >
                  <div>
                    Promotion code :
                    <span style="font-weight: bold">{{
                      order_detail.order_discount_code
                    }}</span>
                  </div>
                  <div>
                    Promotion name :
                    <span style="color: grey"
                      >{{ order_detail.order_discount.promotion_name_th }} (
                      {{ order_detail.order_discount.promotion_detail }} )</span
                    >
                  </div>
                </div>
              </v-flex>
              <v-flex xs3>
                <v-btn
                  @click="deletePromotion()"
                  :disabled="
                    deletingPromotion ||
                    isEditOrder ||
                    (order_status_id == 6 &&
                      $store.state.permission.order.edit_view != 3) ||
                    (order_status_id == 7 &&
                      $store.state.permission.order.edit_view != 3) ||
                    (order_detail.order_status == 7 &&
                      $store.state.permission.order.edit_view != 3) ||
                    $route.name == 'OrderDetailMessenger'
                  "
                  :loading="deletingPromotion"
                  v-if="
                    order_detail.order_discount != null &&
                    order_detail.order_discount_code != null
                  "
                  >remove</v-btn
                >
              </v-flex>
            </v-layout>
          </v-card>
          <!-- <div
            style="color:grey;padding:10px 0 10px 20px;text-align:left;font-size:16px;"
            v-if="order_detail.order_discount == null && order_detail.order_discount_code != null"
          >Recent promotion : {{order_detail.order_discount_code }}</div>
          <div
            style="color:green;padding:10px 0 10px 20px;text-align:left;font-size:16px;"
            v-if="order_detail.order_discount != null && order_detail.order_discount_code != null"
          >
            <div>Promotion code : {{order_detail.order_discount_code }}</div>

            <div>Promotion name : {{order_detail.order_discount.promotion_name_th }} - {{order_detail.order_discount.promotion_detail}}</div>
          </div>-->
        </v-flex>
      </v-layout>
    </v-card>
    <chatlog
      :openDialogChat="openDialogChat"
      :statusBtn="statusBtn"
      :order_detail_message="order_detail"
      :provinceData="provinceData"
      @toggleDialogChat="toggleDialogChat"
    />
    <v-layout row wrap>
      <v-flex xs12>
        <v-card flat class="mt-3 order-section-card">
          <v-card-text>
            <rider-information
              @cloneOrder="cloneOrder()"
              :order_detail="order_detail"
              :header-action-layout="true"
            />
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <orderLog class="mt-3" :order_detail="order_detail" />
    <v-dialog v-model="cancelDialog" persistent max-width="300px">
      <v-card
        ><v-card-title style="background-color: #212121"
          ><h3 style="color: white">Why do you want to cancel ?</h3>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="
              cancelDialog = false;
              cancelRemark = '';
            "
          >
            <v-icon color="white">close</v-icon></v-btn
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="formCancel">
            <v-text-field
              label="Reason"
              v-model="cancelRemark"
              :rules="[
                (v) => !!v || 'Required',
                (v) =>
                  v.replace(/\ /g, '').replace(/\-/g, '') != '' ||
                  'No symbol only',
              ]"
            ></v-text-field></v-form
        ></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" style="color: #212121" @click="cancelOrder()"
            >submit</v-btn
          ></v-card-actions
        ></v-card
      >
    </v-dialog>
    <dispatch-candidate-dialog
      :dialog="dispatchPreviewDialog"
      :preview="dispatchPreviewData"
      :loading="dispatchPreviewLoading"
      :confirmLoading="dispatchLoading"
      :mode="dispatchPreviewMode"
      @dialog="dispatchPreviewDialog = $event"
      @confirm="confirmDispatchPreview"
    />
  </div>
</template>

<script>
import OrderIncentiveDialog from "./OrderIncentiveDialog.vue";
import chatlog from "../OrderOnline/OrderDetail/Chat";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import imageDialog from "./ImageDialog";
import riderInformation from "./OrderDetail/RiderInformation.vue";
import orderLog from "./OrderDetail/OrderLog.vue";
import DispatchCandidateDialog from "./DispatchCandidateDialog.vue";
import realtimeDispatchSocket from "@/services/realtimeDispatchSocket";
import appConfigFeatureService from "@/services/appConfigFeatureService";
import { mapState, mapGetters } from "vuex";
import Swal from "sweetalert2";
export default {
  props: ["order_id"],
  components: {
    OrderIncentiveDialog,
    chatlog,
    VueTimepicker,
    imageDialog,
    riderInformation,
    orderLog,
    DispatchCandidateDialog,
  },
  data() {
    return {
      deletingPromotion: false,
      statusBtn: "",
      openDialogChat: false,
      codLoading: false,
      start_date_menu: false,
      place_name: null,
      fetching_data: false,
      original_data: {},
      using_promo_code: false,
      use_promo_code: "",
      canceling_order: false,
      update_loading: 0,
      original_end_time: {},
      original_end_date: null,
      end_date: null,
      end_time: {},
      original_start_time: {},
      original_start_date: null,
      start_date: null,
      start_time: {},
      view_img_position: null,
      form_rider: {},
      changing_rider: false,
      change_rider: [],
      headers: [
        { text: "No.", align: "center", sortable: false, value: "num" },
        { text: "Time", value: "time", sortable: false, align: "center" },
        { text: "User", value: "user", sortable: false, align: "center" },
      ],
      log: [
        {
          num: "1",
          time: "11:59",
          user: "nynk",
        },
        {
          num: "2",
          time: "13:00",
          user: "piew",
        },
      ],
      expand: false,
      imageDialog: false,
      place: 5,
      add_on_value: ["ไป-กลับ", "กล่องใส่อาหาร"],
      date: new Date().toISOString().substr(0, 10),
      menu2: false,
      status: [
        { name: "Order made", value: 1 },
        { name: "In queue", value: 2 },
        { name: "On the way", value: 5 },
        { name: "Completed", value: 6 },
      ],
      pay: [
        { name: "Cash", value: 1 },
        { name: "Credit card", value: 2 },
      ],
      pay_status: [
        { name: "Paid", value: 2 },
        { name: "Not pay", value: 1 },
      ],
      cancelRemark: "",
      cancelDialog: false,
      directionRoute: [],
      dispatchLoading: false,
      dispatchOfferLoading: false,
      dispatchPreviewDialog: false,
      dispatchPreviewLoading: false,
      dispatchPreviewData: null,
      dispatchPreviewRequest: null,
      dispatchPreviewMode: "request",
      dispatchSocket: null,
      dispatchSocketState: "connecting",
      dispatchReconnectTimer: null,
      dispatchHeartbeatTimer: null,
      dispatchStatusPollTimer: null,
      liveDispatchStatus: null,
    };
  },
  computed: {
    incentiveProvince() {
      return String(
        this.$route.params.province ||
          this.$store.state.backOffice.province ||
          ""
      )
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "");
    },
    ...mapState({
      order_status_id: (state) => state.fetchOrderListBack.order_status_id,
      order_detail: (state) => state.fetchOrderDetailBack.order_detail_me,
      vehicle_list: (state) => state.fetchOrderDetailBack.vehicle_list,
      add_on_list: (state) => state.fetchOrderDetailBack.add_on_list_me,
      provinceData: (state) => state.fetchProvinceBack.provinceData,
    }),
    ...mapGetters({
      isEditOrder: "isEditOrder",
    }),
    isAutoDispatchFeatureEnabled() {
      return appConfigFeatureService.isFeatureEnabled(
        "auto_dispatch_order_system",
        {
          defaultValue: true,
        }
      );
    },
    isFinalStatus() {
      return this.order_status_id == 6 || this.order_status_id == 7;
    },
    dispatchActionLabel() {
      if (this.dispatchSocketState !== "connected") {
        return "Connecting";
      }
      return "Retry Dispatch";
    },
    dispatchButtonLoading() {
      return (
        this.dispatchOfferLoading ||
        this.dispatchPreviewLoading ||
        this.dispatchLoading
      );
    },
    hasAssignedRider() {
      return Boolean(
        this.order_detail?.order_rider_id ||
          this.order_detail?.order_rider_full_name
      );
    },
    isDispatchReady() {
      return (
        String(this.order_detail?.order_dispatch_state || "").toUpperCase() ===
        "READY_FOR_DISPATCH"
      );
    },
    dispatchLifecycleStatus() {
      if (this.hasAssignedRider) {
        return "assigned";
      }
      const liveStatus = String(
        this.liveDispatchStatus?.dispatchStatus ||
          this.liveDispatchStatus?.status ||
          ""
      )
        .toLowerCase()
        .trim();
      if (
        liveStatus === "dispatching" ||
        liveStatus === "assigned" ||
        liveStatus === "failed"
      ) {
        return liveStatus;
      }
      const storedStatus = String(this.order_detail?.dispatch_status || "")
        .toLowerCase()
        .trim();
      if (
        storedStatus === "dispatching" ||
        storedStatus === "assigned" ||
        storedStatus === "failed"
      ) {
        return storedStatus;
      }
      if (this.isDispatchReady) {
        return "idle";
      }
      return null;
    },
    canRetryDispatch() {
      return this.dispatchLifecycleStatus === "failed";
    },
    dispatchRetryDisabled() {
      return (
        this.dispatchButtonLoading ||
        this.dispatchSocketState !== "connected" ||
        this.isEditOrder ||
        !this.canRetryDispatch
      );
    },
    showDispatchAction() {
      return (
        this.isAutoDispatchFeatureEnabled &&
        !this.hasAssignedRider &&
        this.isDispatchReady &&
        this.dispatchLifecycleStatus !== "assigned"
      );
    },
    dispatchStatusText() {
      if (
        !this.isDispatchReady &&
        !this.liveDispatchStatus &&
        !this.hasAssignedRider
      ) {
        if (this.hasDispatchContext && !this.isFinalStatus) {
          return this.dispatchSocketState === "connected"
            ? "Waiting for dispatch status"
            : "Connecting to dispatch";
        }
        return "";
      }
      if (this.dispatchLifecycleStatus === "dispatching") {
        const riderName =
          this.liveDispatchStatus?.currentRiderName ||
          this.liveDispatchStatus?.currentRiderId ||
          "";
        return riderName
          ? `Dispatching... offering to ${riderName}`
          : "Dispatching...";
      }
      if (this.dispatchLifecycleStatus === "failed") {
        return "Failed (retry available)";
      }
      if (this.dispatchLifecycleStatus === "assigned") {
        return "Rider assigned";
      }
      if (this.isDispatchReady) {
        return "Waiting for rider";
      }
      return "";
    },
    dispatchCandidateNamesText() {
      const candidateNames = Array.isArray(
        this.liveDispatchStatus?.candidateRiderNames
      )
        ? this.liveDispatchStatus.candidateRiderNames
            .map((value) => String(value || "").trim())
            .filter(Boolean)
        : [];
      if (!candidateNames.length) {
        return "";
      }
      return `Candidates: ${candidateNames.join(", ")}`;
    },

    showChangeToCOD() {
      if (!this.order_detail || !this.order_detail.order_id) return false;
      // Show when payment type is not already Cash (1), not final status, have permission, not editing
      const isAlreadyCOD = this.order_detail.order_payment_type == 1;
      return (
        !isAlreadyCOD &&
        !this.isFinalStatus &&
        !this.isEditOrder &&
        this.$route.name != "OrderDetailMessenger" // Keep consistent with other disabled conditions
      );
    },
    hasDispatchContext() {
      if (!this.isAutoDispatchFeatureEnabled) {
        return false;
      }
      return Boolean(
        this.order_detail &&
          Object.keys(this.order_detail).length > 0 &&
          this.resolveDispatchOrderId() &&
          !this.hasAssignedRider
      );
    },
    shouldShowDispatchTimeline() {
      return this.dispatchTimeline.length > 0;
    },
    dispatchTimeline() {
      if (!this.isAutoDispatchFeatureEnabled) {
        return [];
      }
      if (this.liveDispatchStatus) {
        return this.buildDispatchTimelineFromStatus(this.liveDispatchStatus);
      }
      if (this.hasAssignedRider) {
        return [
          { label: "Dispatch Started", color: "grey" },
          { label: "Offering Rider", color: "grey" },
          { label: "Rider Assigned", color: "#fddf00" },
        ];
      }
      if (this.dispatchSocketState !== "connected") {
        return this.buildDispatchConnectionTimeline();
      }
      const state = this.getDispatchState(this.order_detail);
      if (!state) return [];
      const highlight = "#fddf00";
      const base = ["Dispatch Started", "Offering Rider"];
      if (state === "offering") {
        return base.map((label, index) => ({
          label,
          color: index === 1 ? highlight : "grey",
        }));
      }
      if (state === "assigned") {
        const items = [...base, "Rider Accepted"];
        return items.map((label, index) => ({
          label,
          color: index === 2 ? highlight : "grey",
        }));
      }
      if (state === "open_list") {
        const items = [...base, "Open List"];
        return items.map((label, index) => ({
          label,
          color: index === 2 ? highlight : "grey",
        }));
      }
      if (state === "manual") {
        const items = ["Dispatch Started", "Manual Dispatch", "Rider Assigned"];
        return items.map((label, index) => ({
          label,
          color: index === 1 ? highlight : "grey",
        }));
      }
      if (state === "ready_for_dispatch" || this.isDispatchReady) {
        return [
          { label: "Ready For Dispatch", color: "grey" },
          { label: "Waiting For Rider", color: highlight },
        ];
      }
      if (this.hasDispatchContext && !this.isFinalStatus) {
        return [
          { label: "Dispatch Monitoring", color: "grey" },
          { label: "Waiting For Dispatch Status", color: highlight },
        ];
      }
      return [];
    },
    update_btn() {
      this.update_btn_disable = this.unSavedData();
      return this.update_btn_disable;
    },
  },
  methods: {
    getDispatchState(item) {
      if (!item) return null;
      if (item.order_rider_id || item.order_rider_full_name) {
        return "assigned";
      }
      const raw =
        item.dispatch_state ||
        item.order_dispatch_state ||
        item.dispatchState ||
        item.dispatch_status ||
        item.dispatch_status_id;
      if (raw == null) return null;
      const normalized = String(raw).toLowerCase().trim();
      if (normalized === "ready_for_dispatch") {
        return "ready_for_dispatch";
      }
      if (
        normalized === "searching" ||
        normalized === "offering" ||
        normalized === "offering_rider"
      ) {
        return "offering";
      }
      if (normalized === "assigned") return "assigned";
      if (
        normalized === "broadcast" ||
        normalized === "open_list" ||
        normalized === "openlist"
      ) {
        return "open_list";
      }
      if (normalized === "manual") return "manual";
      return normalized;
    },
    resolveDispatchOrderId() {
      return String(
        this.order_detail?.order_code ||
          this.order_detail?.order_id ||
          this.order_id ||
          ""
      ).trim();
    },
    getDispatchGatewayBase() {
      return String(process.env.VUE_APP_REALTIME_GATEWAY_URL || "").trim();
    },
    getCoreBackendBase() {
      return String(process.env.VUE_APP_BACKEND_URL || "").trim();
    },
    getCoreBackendApiVersion() {
      return String(process.env.VUE_APP_BACKEND_API_VERSION || "").trim();
    },
    resolveProvinceRouteZoneId() {
      const routeProvince = String(this.$route.params.province || "").trim();
      if (!routeProvince || !Array.isArray(this.provinceData)) {
        return "";
      }

      const normalizeProvinceValue = (value) =>
        String(value || "")
          .trim()
          .toLowerCase()
          .replace(/\s+/g, "")
          .replace(/-/g, "");

      const normalizedRouteProvince = normalizeProvinceValue(routeProvince);
      const matchedProvince = this.provinceData.find((province) => {
        const provinceId = String(province?.province_id || "").trim();
        const provinceNameEn = normalizeProvinceValue(
          province?.province_name_en
        );

        return (
          provinceId === routeProvince ||
          provinceNameEn === normalizedRouteProvince
        );
      });

      return matchedProvince ? String(matchedProvince.province_id).trim() : "";
    },
    formatDispatchAddress(...values) {
      const normalized = values
        .map((value) => String(value || "").trim())
        .filter(Boolean);
      return normalized[0] || "";
    },
    getDispatchOfferDetailsUrl(orderCode) {
      const backendBase = this.getCoreBackendBase();
      const apiVersion = this.getCoreBackendApiVersion();
      const routeProvince = String(this.$route.params.province || "").trim();
      const normalizedOrderCode = String(orderCode || "").trim();

      if (!backendBase) {
        throw new Error("VUE_APP_BACKEND_URL is not configured.");
      }
      if (!apiVersion) {
        throw new Error("VUE_APP_BACKEND_API_VERSION is not configured.");
      }
      if (!routeProvince || !normalizedOrderCode) {
        throw new Error("Order province or order code is missing.");
      }

      return `${backendBase}/api/v${apiVersion}/${routeProvince}/dispatch/order_offer/${encodeURIComponent(
        normalizedOrderCode
      )}`;
    },
    normalizeDispatchOfferResponse(baseRequest, payload) {
      const data = payload?.data || {};
      const merchant = data?.merchant || {};
      const fallbackMerchant = baseRequest?.merchant || {};
      const fallbackDetails = baseRequest?.offerDetails || {};
      const lat = Number(merchant?.lat);
      const lng = Number(merchant?.lng);
      const zoneId = String(
        merchant?.zoneId ?? fallbackMerchant?.zoneId ?? ""
      ).trim();
      const transferPrice =
        data?.orders_transfer_price ??
        fallbackDetails?.ordersTransferPrice ??
        fallbackDetails?.deliveryFee ??
        null;
      const payAtStore =
        data?.pay_at_store ??
        fallbackDetails?.payAtStore ??
        fallbackDetails?.payAtStoreAmount ??
        null;

      return {
        ...baseRequest,
        merchant: {
          lat: Number.isFinite(lat) ? lat : fallbackMerchant?.lat,
          lng: Number.isFinite(lng) ? lng : fallbackMerchant?.lng,
          zoneId,
        },
        offerDetails: {
          ...fallbackDetails,
          ordersId:
            data?.orders_id ??
            fallbackDetails?.ordersId ??
            this.order_detail?.orders_id ??
            this.order_detail?.order_id ??
            null,
          orderCode: String(
            data?.order_code ||
              fallbackDetails?.orderCode ||
              baseRequest?.orderId ||
              ""
          ).trim(),
          orderType: String(
            data?.order_type || fallbackDetails?.orderType || "messenger"
          ).trim(),
          restaurantName: this.formatDispatchAddress(
            data?.restaurant_name,
            fallbackDetails?.restaurantName
          ),
          startPoint: this.formatDispatchAddress(
            data?.start_point,
            fallbackDetails?.startPoint
          ),
          endPoint: this.formatDispatchAddress(
            data?.end_point,
            fallbackDetails?.endPoint
          ),
          deliveryFee: transferPrice,
          ordersTransferPrice: transferPrice,
          payAtStoreAmount: payAtStore,
          payAtStore,
          pointCount:
            Number(data?.point_count) > 0
              ? Number(data.point_count)
              : fallbackDetails?.pointCount || 2,
        },
      };
    },
    async prepareDispatchRequest() {
      const baseRequest = this.buildDispatchRequest();
      const url = this.getDispatchOfferDetailsUrl(baseRequest.orderId);
      this.dispatchOfferLoading = true;
      try {
        const res = await fetch(url, {
          method: "GET",
          headers: {
            Authorization: localStorage.getItem("token") || "",
          },
        });
        const payload = await res.json().catch(() => ({}));

        if (!res.ok || payload?.msg !== true || !payload?.data) {
          throw new Error(payload?.error || "dispatch_offer_details_failed");
        }

        return this.normalizeDispatchOfferResponse(baseRequest, payload);
      } finally {
        this.dispatchOfferLoading = false;
      }
    },
    getDispatchAuthorizationHeader() {
      const token = String(localStorage.getItem("token") || "").trim();
      if (!token) return "";
      return token.toLowerCase().startsWith("bearer ")
        ? token
        : `Bearer ${token}`;
    },
    getDispatchErrorMessage(errorCode, fallbackMessage) {
      const normalized = String(errorCode || "")
        .trim()
        .toLowerCase();
      if (normalized === "unauthorized") {
        return "Your session is invalid or expired. Please sign in again.";
      }
      if (
        normalized === "verify_failed" ||
        normalized === "verify_url_missing"
      ) {
        return "Dispatch auth service is unavailable right now. Please try again.";
      }
      if (normalized === "forbidden") {
        return "This action is not allowed for the current account.";
      }
      return fallbackMessage;
    },
    getDispatchWebSocketUrl() {
      const gatewayBase = this.getDispatchGatewayBase();
      if (!gatewayBase) return "";
      try {
        const parsed = new URL(gatewayBase);
        parsed.protocol = parsed.protocol === "https:" ? "wss:" : "ws:";
        parsed.pathname = "/ws";
        parsed.search = "";
        parsed.hash = "";
        return parsed.toString();
      } catch (error) {
        return "";
      }
    },
    buildDispatchTimelineFromStatus(statusPayload) {
      const status = String(
        statusPayload?.phase ||
          statusPayload?.state ||
          statusPayload?.status ||
          ""
      ).toUpperCase();
      const radius = Number(statusPayload?.radius || 0);
      const attempt = Number(statusPayload?.attempt || 0);
      const checkedRiders = Number(statusPayload?.checkedRiders || 0);
      const candidateRiderNames = Array.isArray(
        statusPayload?.candidateRiderNames
      )
        ? statusPayload.candidateRiderNames
            .map((value) => String(value || "").trim())
            .filter(Boolean)
        : [];
      const currentRiderName = String(
        statusPayload?.currentRiderName || statusPayload?.currentRiderId || ""
      ).trim();
      const candidateSummary =
        candidateRiderNames.length > 0
          ? `Candidates: ${candidateRiderNames.slice(0, 3).join(", ")}${
              candidateRiderNames.length > 3
                ? ` +${candidateRiderNames.length - 3} more`
                : ""
            }`
          : null;
      const detail = [
        attempt > 0 ? `Attempt ${attempt}` : null,
        radius > 0 ? `${radius} km` : null,
        Number.isFinite(checkedRiders)
          ? `${checkedRiders} riders checked`
          : null,
        currentRiderName ? `Offering to ${currentRiderName}` : null,
        candidateSummary,
      ]
        .filter(Boolean)
        .join(" • ");

      const withDetail = (label) => (detail ? `${label} (${detail})` : label);
      const highlight = "#fddf00";
      const warning = "#fb8c00";
      const danger = "#e53935";

      if (status === "SEARCHING") {
        return [{ label: withDetail("Searching Riders"), color: highlight }];
      }
      if (status === "OFFERING") {
        return [
          { label: "Dispatch Started", color: "grey" },
          { label: withDetail("Offering Rider"), color: highlight },
        ];
      }
      if (status === "ASSIGNED") {
        return [
          { label: "Dispatch Started", color: "grey" },
          { label: "Offering Rider", color: "grey" },
          { label: withDetail("Rider Assigned"), color: highlight },
        ];
      }
      if (status === "BROADCAST") {
        return [
          { label: "Dispatch Started", color: "grey" },
          { label: "Offering Rider", color: "grey" },
          { label: withDetail("Broadcast To Order List"), color: warning },
        ];
      }
      if (status === "FAILED") {
        return [
          { label: "Dispatch Started", color: "grey" },
          { label: withDetail("No Rider Accepted"), color: danger },
        ];
      }
      return [];
    },
    buildDispatchConnectionTimeline() {
      const danger = "#e53935";
      const info = "#1e88e5";
      if (this.dispatchSocketState === "failed") {
        return [
          {
            label: "Dispatch Connection Failed",
            color: danger,
          },
        ];
      }
      if (this.dispatchSocketState === "connecting") {
        return [
          {
            label: "Dispatch Connecting",
            color: info,
          },
        ];
      }
      return [];
    },
    applyDispatchStatus(payload) {
      if (!payload) return;
      const currentOrderId = this.resolveDispatchOrderId();
      if (!currentOrderId || String(payload.orderId || "") !== currentOrderId) {
        return;
      }
      this.liveDispatchStatus = {
        orderId: currentOrderId,
        status: payload.status,
        dispatchStatus:
          payload.dispatchStatus ||
          (["SEARCHING", "OFFERING"].includes(
            String(payload.status || "").toUpperCase()
          )
            ? "dispatching"
            : String(payload.status || "").toUpperCase() === "BROADCAST"
            ? "failed"
            : payload.status),
        phase: payload.phase || payload.state || payload.status,
        radius: payload.radius,
        attempt: payload.attempt,
        checkedRiders: payload.checkedRiders,
        assignedRiderId: payload.assignedRiderId || null,
        failureReason: payload.failureReason || null,
        currentRiderId: payload.currentRiderId || null,
        currentRiderName: payload.currentRiderName || null,
        candidateRiderIds: Array.isArray(payload.candidateRiderIds)
          ? payload.candidateRiderIds
          : [],
        candidateRiderNames: Array.isArray(payload.candidateRiderNames)
          ? payload.candidateRiderNames
          : [],
      };
      this.$store.commit("fetchOrderDetailBack/updateDataME", {
        ...this.order_detail,
        dispatch_status: this.liveDispatchStatus.dispatchStatus || null,
        dispatch_state: this.getDispatchState({
          dispatch_state:
            this.liveDispatchStatus.phase || this.liveDispatchStatus.status,
        }),
        dispatch_phase: this.liveDispatchStatus.phase || null,
        order_dispatch_state:
          this.order_detail?.order_dispatch_state ||
          (this.liveDispatchStatus.dispatchStatus
            ? "READY_FOR_DISPATCH"
            : null),
      });
      this.$store.commit("fetchOrderListBack/updateDispatchStatus", payload);
    },
    applyOptimisticRetryState() {
      const orderId = this.resolveDispatchOrderId();
      if (!orderId) {
        return;
      }

      const previewAttempts = Array.isArray(this.dispatchPreviewData?.attempts)
        ? this.dispatchPreviewData.attempts
        : [];
      const firstAttempt =
        previewAttempts.find(
          (attempt) =>
            Array.isArray(attempt?.candidates) && attempt.candidates.length > 0
        ) ||
        previewAttempts[0] ||
        null;
      const candidateRiderNames = Array.isArray(firstAttempt?.candidates)
        ? firstAttempt.candidates
            .map((candidate) =>
              String(candidate?.riderName || candidate?.riderId || "").trim()
            )
            .filter(Boolean)
        : [];
      const candidateRiderIds = Array.isArray(firstAttempt?.candidates)
        ? firstAttempt.candidates
            .map((candidate) => String(candidate?.riderId || "").trim())
            .filter(Boolean)
        : [];

      this.applyDispatchStatus({
        orderId,
        status: "dispatching",
        dispatchStatus: "dispatching",
        phase: "OFFERING",
        attempt: Number(firstAttempt?.attempt || 1),
        radius: Number(firstAttempt?.radius || 0),
        checkedRiders: Number(
          firstAttempt?.checkedRiders || candidateRiderIds.length || 0
        ),
        currentRiderId: candidateRiderIds[0] || null,
        currentRiderName: candidateRiderNames[0] || null,
        candidateRiderIds,
        candidateRiderNames,
        failureReason: null,
      });
    },
    startDispatchStatusPolling() {
      this.stopDispatchStatusPolling();
      this.dispatchStatusPollTimer = setInterval(() => {
        this.hydrateDispatchStatus();
      }, 5000);
    },
    stopDispatchStatusPolling() {
      clearInterval(this.dispatchStatusPollTimer);
      this.dispatchStatusPollTimer = null;
    },
    scheduleDispatchReconnect() {
      clearTimeout(this.dispatchReconnectTimer);
      this.dispatchReconnectTimer = setTimeout(() => {
        this.connectDispatchSocket();
      }, 3000);
    },
    startDispatchHeartbeat(socket) {
      this.stopDispatchHeartbeat();
      this.dispatchHeartbeatTimer = setInterval(() => {
        if (
          socket &&
          socket === this.dispatchSocket &&
          socket.readyState === WebSocket.OPEN
        ) {
          try {
            socket.send("ping");
          } catch (error) {
            // no-op
          }
        }
      }, 25000);
    },
    stopDispatchHeartbeat() {
      clearInterval(this.dispatchHeartbeatTimer);
      this.dispatchHeartbeatTimer = null;
    },
    async hydrateDispatchStatus() {
      const gatewayBase = this.getDispatchGatewayBase();
      const token = localStorage.getItem("token") || "";
      const orderId = this.resolveDispatchOrderId();
      if (!gatewayBase || !token || !orderId) {
        return;
      }

      try {
        const res = await fetch(`${gatewayBase}/dispatch/status/bulk`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ orderIds: [orderId] }),
        });
        const data = await res.json();
        const payload = Array.isArray(data?.statuses) ? data.statuses[0] : null;
        if (!res.ok || !data?.ok || (!payload?.status && !payload?.phase)) {
          return;
        }
        this.applyDispatchStatus(payload);
      } catch (error) {
        // no-op
      }
    },
    connectDispatchSocket() {
      if (!this.isAutoDispatchFeatureEnabled) {
        this.disconnectDispatchSocket(false);
        this.dispatchSocketState = "disabled";
        return;
      }
      const gatewayBase = this.getDispatchGatewayBase();
      const token = localStorage.getItem("token") || "";
      const orderId = this.resolveDispatchOrderId();
      if (!gatewayBase || !token || !orderId) {
        this.dispatchSocketState = "failed";
        return;
      }

      if (!this.dispatchSocketSubscription) {
        this.dispatchSocketSubscription = realtimeDispatchSocket.subscribe({
          onStateChange: (state) => {
            this.dispatchSocketState = state;
            if (state === "connected") {
              this.syncDispatchSubscriptions();
              this.hydrateDispatchStatus();
            }
          },
          onDispatchStatus: (payload) => {
            this.applyDispatchStatus(payload);
          },
        });
      }

      realtimeDispatchSocket.ensureConnection({
        gatewayBase,
        token,
      });
      this.syncDispatchSubscriptions();
    },
    disconnectDispatchSocket(allowClose = true) {
      clearTimeout(this.dispatchReconnectTimer);
      this.dispatchReconnectTimer = null;
      this.stopDispatchStatusPolling();
      if (this.dispatchSocketSubscription) {
        this.dispatchSocketSubscription.dispose();
        this.dispatchSocketSubscription = null;
      }
      if (allowClose) {
        this.dispatchSocketState = "connecting";
      }
    },
    syncDispatchSubscriptions() {
      if (!this.dispatchSocketSubscription) {
        return;
      }
      const orderId = this.resolveDispatchOrderId();
      this.dispatchSocketSubscription.updateOrderIds(orderId ? [orderId] : []);
    },
    async handleChangeToCOD() {
      if (!this.order_detail || !this.order_detail.order_id) return;
      const confirmResult = await Swal.fire({
        icon: "question",
        title: "Change payment to COD?",
        text: "This will switch the payment method to Cash on Delivery.",
        showCancelButton: true,
        confirmButtonText: "Yes, change",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#1976d2",
      });
      if (!confirmResult.isConfirmed) return;
      this.codLoading = true;
      const province = this.$route.params.province;
      const res = await this.$store.dispatch(
        "fetchOrderListBack/changeOrderPaymentToCOD",
        { province, order_id: this.order_detail.order_id }
      );
      this.codLoading = false;
      if (res && res.order_already_paid) {
        Swal.fire({
          icon: "warning",
          title: "Already paid",
          text: "Order already paid. Cannot change payment type.",
        });
        return;
      }
      if (res === false) {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: "Unable to change payment type to COD.",
        });
        return;
      }
      this.order_detail.order_payment_type = 1; // reflect instantly
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Payment type changed to COD.",
        timer: 1800,
        showConfirmButton: false,
      });
    },
    async fetchDirectionRoute(points) {
      // Mapbox Directions API for multiple waypoints

      if (!points || points.length < 2) return;
      const accessToken =
        "pk.eyJ1IjoiYWxpY29ybnRlY2gxMjMiLCJhIjoiY21hMzd0M3l2MmFpajJrczd5cDFxZ3pnMSJ9.sz_Iu4K8W746uriOgMIT-w";
      // Build waypoints string: lng,lat;lng,lat;...
      const waypoints = points
        .map((p) => `${p.longitude},${p.latitude}`)
        .join(";");
      const url = `https://api.mapbox.com/directions/v5/mapbox/driving/${waypoints}?geometries=polyline&access_token=${accessToken}`;
      try {
        const res = await fetch(url);
        const data = await res.json();
        if (data.routes && data.routes.length > 0) {
          this.directionRoute = this.decodePolyline(data.routes[0].geometry);
        }
      } catch (e) {
        this.directionRoute = [];
      }
    },
    decodePolyline(str) {
      let index = 0,
        lat = 0,
        lng = 0,
        coordinates = [];
      while (index < str.length) {
        let b,
          shift = 0,
          result = 0;
        do {
          b = str.charCodeAt(index++) - 63;
          result |= (b & 0x1f) << shift;
          shift += 5;
        } while (b >= 0x20);
        let dlat = result & 1 ? ~(result >> 1) : result >> 1;
        lat += dlat;
        shift = 0;
        result = 0;
        do {
          b = str.charCodeAt(index++) - 63;
          result |= (b & 0x1f) << shift;
          shift += 5;
        } while (b >= 0x20);
        let dlng = result & 1 ? ~(result >> 1) : result >> 1;
        lng += dlng;
        coordinates.push({ latitude: lat / 1e5, longitude: lng / 1e5 });
      }
      return coordinates;
    },
    async deletePromotion() {
      this.deletingPromotion = true;
      let check = await this.$store.dispatch(
        "fetchOrderDetailBack/deletePromotion",
        this.order_detail
      );
      if (check != false) {
        this.$emit("cloneOrder");
      }
      await this.$store.dispatch(
        "fetchOrderListBack/getOrderList",
        this.order_status_id
      );
      this.deletingPromotion = false;
    },
    toggleDialogChat(value) {
      this.openDialogChat = !value;
      // this.statusBtn = "";
    },
    dialogToggle() {
      this.openDialogChat = !this.openDialogChat;
      this.statusBtn = "oder_mess_detail";
    },
    buildDispatchRequest() {
      const orderPoints = Array.isArray(this.order_detail?.order_point)
        ? [...this.order_detail.order_point]
        : [];
      orderPoints.sort((left, right) => {
        const leftOrder = Number(
          left?.order_point_number ?? Number.MAX_SAFE_INTEGER
        );
        const rightOrder = Number(
          right?.order_point_number ?? Number.MAX_SAFE_INTEGER
        );
        if (leftOrder !== rightOrder) {
          return leftOrder - rightOrder;
        }
        return (
          Number(left?.order_point_id || 0) - Number(right?.order_point_id || 0)
        );
      });
      const firstPoint =
        orderPoints.find(
          (point) =>
            Number(point?.order_point_number) === 1 ||
            Number(point?.order_point_status) === 1
        ) ||
        orderPoints[0] ||
        {};
      const firstPosition = Array.isArray(this.order_detail?.order_position)
        ? this.order_detail.order_position[0] || {}
        : {};
      const orderId = String(
        this.order_detail?.order_code ||
          this.order_detail?.order_id ||
          this.order_id ||
          ""
      ).trim();
      const lat = Number(
        firstPoint.order_point_lat ||
          firstPosition.position_lat ||
          this.order_detail?.order_point_lat ||
          this.order_detail?.store_lat
      );
      const lng = Number(
        firstPoint.order_point_long ||
          firstPoint.order_point_lng ||
          firstPosition.position_long ||
          firstPosition.position_lng ||
          this.order_detail?.order_point_long ||
          this.order_detail?.store_lng
      );
      const zoneId = String(
        firstPoint.order_point_zone_id ||
          this.order_detail?.order_zone_id ||
          this.order_detail?.zone_id ||
          this.order_detail?.province_id ||
          this.order_detail?.order_province_id ||
          this.order_detail?.order_customer_address
            ?.customer_address_province_id ||
          this.resolveProvinceRouteZoneId() ||
          this.$route.params.province ||
          this.order_detail?.order_districts_name ||
          this.order_detail?.order_districts_id ||
          ""
      ).trim();

      if (
        !orderId ||
        !zoneId ||
        !Number.isFinite(lat) ||
        !Number.isFinite(lng)
      ) {
        throw new Error(
          "Order is missing pickup latitude, longitude, or zone."
        );
      }

      const gatewayBase = String(
        process.env.VUE_APP_REALTIME_GATEWAY_URL || ""
      ).trim();

      if (!gatewayBase) {
        throw new Error("VUE_APP_REALTIME_GATEWAY_URL is not configured.");
      }

      const firstOrderPoint = orderPoints[0] || {};
      const lastOrderPoint = orderPoints[orderPoints.length - 1] || {};
      const startPoint = this.formatDispatchAddress(
        firstOrderPoint.order_point_address,
        firstPosition.position_name,
        `Order #${orderId}`
      );
      const endPoint = this.formatDispatchAddress(
        lastOrderPoint.order_point_address,
        "ลูกค้าปลายทาง"
      );
      const deliveryFee =
        this.order_detail?.order_transfer_price ??
        this.order_detail?.order_delivery_price ??
        this.order_detail?.orders_transfer_price ??
        this.order_detail?.order_delivery_fee ??
        this.order_detail?.delivery_fee ??
        this.order_detail?.delivery_price ??
        null;
      const payAtStoreAmount = this.order_detail?.pay_at_store ?? null;

      return {
        orderId,
        gatewayBase,
        merchant: { lat, lng, zoneId },
        offerDetails: {
          ordersId:
            this.order_detail?.orders_id ?? this.order_detail?.order_id ?? null,
          orderCode: orderId,
          orderType: "messenger",
          restaurantName: `Order #${orderId}`,
          startPoint,
          endPoint,
          deliveryFee,
          ordersTransferPrice: deliveryFee,
          payAtStoreAmount,
          payAtStore: payAtStoreAmount,
          pointCount: orderPoints.length || 2,
        },
      };
    },
    async openDispatchPreview(mode = "request") {
      let request = null;
      try {
        request = await this.prepareDispatchRequest();
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Dispatch data missing",
          text: error?.message || "Unable to prepare dispatch preview.",
        });
        return;
      }

      try {
        this.dispatchPreviewLoading = true;
        const res = await fetch(`${request.gatewayBase}/dispatch/candidates`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: this.getDispatchAuthorizationHeader(),
          },
          body: JSON.stringify({
            orderId: request.orderId,
            merchant: request.merchant,
            offerDetails: request.offerDetails,
          }),
        });
        const payload = await res.json().catch(() => ({}));
        if (!res.ok || payload?.ok === false) {
          throw new Error(
            this.getDispatchErrorMessage(
              payload?.error,
              "dispatch_candidate_preview_failed"
            )
          );
        }
        this.dispatchPreviewRequest = request;
        this.dispatchPreviewData = payload.preview || null;
        this.dispatchPreviewMode = mode === "retry" ? "retry" : "request";
        this.dispatchPreviewDialog = true;
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Candidate preview failed",
          text: error?.message || "Unable to load candidate riders.",
        });
      } finally {
        this.dispatchPreviewLoading = false;
      }
    },
    async confirmDispatchPreview() {
      const success =
        this.dispatchPreviewMode === "retry"
          ? await this.triggerDispatchRetry()
          : await this.triggerDispatch(this.dispatchPreviewRequest);
      if (success) {
        this.dispatchPreviewDialog = false;
      }
    },
    async triggerDispatchRetry() {
      const gatewayBase = this.getDispatchGatewayBase();
      const orderId = this.resolveDispatchOrderId();
      if (!gatewayBase || !orderId) {
        Swal.fire({
          icon: "error",
          title: "Retry unavailable",
          text: "Missing gateway or order information.",
        });
        return false;
      }

      try {
        this.dispatchLoading = true;
        const res = await fetch(`${gatewayBase}/dispatch/retry`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: this.getDispatchAuthorizationHeader(),
          },
          body: JSON.stringify({ orderId }),
        });
        const payload = await res.json().catch(() => ({}));
        if (!res.ok || payload?.ok === false) {
          throw new Error(
            this.getDispatchErrorMessage(
              payload?.error,
              "dispatch_retry_failed"
            )
          );
        }
        this.applyOptimisticRetryState();
        Swal.fire({
          icon: "success",
          title: "Retry queued",
          text: `Order ${orderId} retry was sent to dispatch.`,
          timer: 1800,
          showConfirmButton: false,
        });
        return true;
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Retry failed",
          text: error?.message || "Unable to retry dispatch.",
        });
        return false;
      } finally {
        this.dispatchLoading = false;
      }
    },
    async triggerDispatch(preparedRequest = null) {
      let request = preparedRequest;
      if (!request) {
        try {
          request = await this.prepareDispatchRequest();
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Dispatch data missing",
            text: error?.message || "Unable to prepare dispatch request.",
          });
          return false;
        }
      }

      try {
        this.dispatchLoading = true;
        const res = await fetch(`${request.gatewayBase}/dispatch/request`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: this.getDispatchAuthorizationHeader(),
          },
          body: JSON.stringify({
            orderId: request.orderId,
            merchant: request.merchant,
            offerDetails: request.offerDetails,
          }),
        });
        const payload = await res.json().catch(() => ({}));
        if (!res.ok || payload?.ok === false) {
          throw new Error(
            this.getDispatchErrorMessage(
              payload?.error,
              "dispatch_request_failed"
            )
          );
        }
        Swal.fire({
          icon: "success",
          title: "Dispatch queued",
          text: `Order ${request.orderId} was sent to realtime dispatch.`,
          timer: 1800,
          showConfirmButton: false,
        });
        return true;
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "No Rider Accepted",
          text: error?.message || "Unable to queue dispatch request.",
        });
        return false;
      } finally {
        this.dispatchLoading = false;
      }
    },
    positionLating() {
      let response = [];
      for (let val of this.order_detail.order_point) {
        let position_data = {
          latitude: Number(val.order_point_lat),
          longitude: Number(val.order_point_long),
        };
        response.push(position_data);
      }
      return response;
    },
    orderDataWithoutDispatchRuntimeFields(orderDetail) {
      const data = JSON.parse(JSON.stringify(orderDetail || {}));
      [
        "dispatch_status",
        "dispatch_state",
        "dispatch_phase",
        "order_dispatch_state",
        "order_dispatch_ready_at",
        "order_incentive",
      ].forEach((field) => {
        delete data[field];
      });
      return data;
    },
    cloneOrder() {
      this.original_data = this.orderDataWithoutDispatchRuntimeFields(
        this.order_detail
      );
    },
    unSavedData() {
      if (
        (JSON.stringify(this.original_data) !=
          JSON.stringify(
            this.orderDataWithoutDispatchRuntimeFields(this.order_detail)
          ) ||
          JSON.stringify(this.end_date) !=
            JSON.stringify(this.original_end_date) ||
          JSON.stringify(this.end_time) !=
            JSON.stringify(this.original_end_time) ||
          JSON.stringify(this.start_date) !=
            JSON.stringify(this.original_start_date) ||
          JSON.stringify(this.start_time) !=
            JSON.stringify(this.original_start_time)) &&
        this.fetching_data == false
      ) {
        return false;
      } else {
        return true;
      }
    },
    async usePromotion() {
      this.using_promo_code = true;
      let check = await this.$store.dispatch(
        "fetchOrderDetailBack/usePromotionME",
        {
          order_id: this.order_detail.order_id,
          use_promo_code: this.use_promo_code,
        }
      );
      await this.$store.dispatch(
        "fetchOrderListBack/getOrderList",
        this.order_status_id
      );
      if (check.promotion_status == false) {
        alert(check.data["name_" + this.$i18n.locale]);
      }

      this.using_promo_code = false;
    },
    toCancelOrder() {
      let isUnsavedData = !this.unSavedData();
      if (isUnsavedData == true) {
        alert("ข้อมูลมีการเปลี่ยนแปลง กรุณาอัพเดทก่อน");
      } else {
        this.cancelDialog = true;
        this.cancelRemark = "";
      }
    },
    async cancelOrder() {
      if (!this.$refs.formCancel || !this.$refs.formCancel.validate()) return;
      this.cancelDialog = false;
      this.canceling_order = true;
      const form = {
        order_id: this.order_detail.order_id,
        order_note:
          this.order_detail.order_note +
          " เหตุผลที่ยกเลิก: " +
          this.cancelRemark,
      };
      const check = await this.$store.dispatch(
        "fetchOrderListBack/cancelOrder",
        { ...form, province: this.$route.params.province }
      );
      this.canceling_order = false;
      if (check == 2) {
        this.backToList();
      }
    },
    async updateData() {
      this.order_detail.order_time_start =
        this.start_date +
        "T" +
        this.start_time.HH +
        ":" +
        this.start_time.mm +
        ":00";
      this.order_detail.order_time_end =
        this.end_date + "T" + this.end_time.HH + ":" + this.end_time.mm + ":00";
      this.update_loading = 1;

      this.update_loading = await this.$store.dispatch(
        "fetchOrderDetailBack/updateDataME",
        this.orderDataWithoutDispatchRuntimeFields(this.order_detail)
      );
      if (this.update_loading == 2) {
        this.cloneOrder();
        this.takeTime();
      }
      if (this.update_loading == 2 && this.order_detail.order_status == 6) {
        this.backToList();
      }
    },
    viewIMG(item) {
      this.place_name = item.order_point_address;
      this.view_img_position = item.order_point_submit_photo;
      this.imageDialog = true;
    },
    backToList() {
      if (
        this.$route.params.orderid &&
        this.$route.name == "OrderDetailMessenger"
      ) {
        this.$router.push({
          path:
            "/weserve_admin_login/control/" +
            this.$store.state.backOffice.province +
            "/report/order_report",
        });
      } else {
        let isUnsavedData = !this.unSavedData();
        if (isUnsavedData == true) {
          confirm("คุณต้องการละทิ้งการเปลี่ยนแปลงหรือไม่ ? ") &&
            this.$emit("backListTable", "orderListTable");
        } else {
          this.$emit("backListTable", "orderListTable");
          this.$emit("setPagename", true);
        }
      }
    },
    async changeRider() {
      this.changing_rider = true;
      this.change_rider = await this.$store.dispatch(
        "fetchOrderDetailBack/getDataRider"
      );
      this.changing_rider = false;
    },
    takeTime() {
      if (this.order_detail.order_time_end != null) {
        this.end_date = this.order_detail.order_time_end.substring(0, 10);
        this.end_time = {
          HH: this.order_detail.order_time_end.substring(11, 13),
          mm: this.order_detail.order_time_end.substring(14, 16),
        };
      }
      this.original_end_date = JSON.parse(JSON.stringify(this.end_date));
      this.original_end_time = JSON.parse(JSON.stringify(this.end_time));

      if (this.order_detail.order_time_start) {
        this.start_date = this.order_detail.order_time_start.substring(0, 10);
        this.start_time = {
          HH: this.order_detail.order_time_start.substring(11, 13),
          mm: this.order_detail.order_time_start.substring(14, 16),
        };
      }
      this.original_start_date = JSON.parse(JSON.stringify(this.start_date));
      this.original_start_time = JSON.parse(JSON.stringify(this.start_time));
    },
    async fetchData() {
      this.fetching_data = true;
      await this.$store.dispatch(
        "fetchOrderDetailBack/getOrderDetailME",
        this.order_id
      );
      this.$store.dispatch("fetchOrderDetailBack/getVehicleList");
      if (this.order_detail.order_vehicle_type != undefined) {
        this.$store.dispatch(
          "fetchOrderDetailBack/getAddonME",
          this.order_detail.order_vehicle_type
        );
      }
      this.takeTime();
    },
  },
  async created() {
    if (
      this.$route.params.orderid &&
      this.$route.name == "OrderDetailMessenger"
    ) {
      this.$store.commit("fetchOrderListBack/setOrderStatusID", 6);
    }
    await this.fetchData();
    this.cloneOrder();
    // Prepare direction and custom markers for messenger order
    if (
      this.order_detail &&
      this.order_detail.order_point &&
      this.order_detail.order_point.length > 1
    ) {
      // Build array of points for direction
      const points = this.order_detail.order_point.map((p) => ({
        latitude: parseFloat(p.order_point_lat),
        longitude: parseFloat(p.order_point_long),
      }));
      await this.fetchDirectionRoute(points);
    }
    this.fetching_data = false;
    if (this.isAutoDispatchFeatureEnabled) {
      this.connectDispatchSocket();
      this.startDispatchStatusPolling();
    }
  },
  beforeDestroy() {
    this.disconnectDispatchSocket();
    this.stopDispatchStatusPolling();
  },
};
</script>

<style scoped>
.order-section-card {
  background: rgba(255, 255, 255, 0.68) !important;
  border: 1px solid rgba(255, 255, 255, 0.82) !important;
  border-radius: 16px;
  box-shadow: 0 18px 52px rgba(27, 39, 51, 0.1) !important;
  overflow: hidden;
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
}

.messenger-actions-panel {
  background: rgba(244, 247, 248, 0.72) !important;
  border: 1px solid rgba(255, 255, 255, 0.84) !important;
  border-radius: 16px;
  box-shadow: 0 18px 52px rgba(27, 39, 51, 0.1) !important;
  margin: 12px 0;
  overflow: visible;
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
}

.messenger-actions-panel__body {
  align-items: center;
  display: flex;
  padding: 14px 16px;
}

.messenger-actions-panel__buttons {
  align-items: center;
  display: flex;
  flex: 1 1 520px;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-start;
}

.messenger-action-btn {
  margin: 0 !important;
  min-height: 40px;
}

.messenger-action-btn--danger {
  margin-left: 4px !important;
}

.change-cod-btn {
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0;
}
.change-cod-btn:hover {
  filter: brightness(0.95);
}

@media (max-width: 960px) {
  .messenger-actions-panel__buttons {
    flex-basis: auto;
  }

  .messenger-actions-panel__buttons {
    justify-content: flex-start;
  }
}

@media (max-width: 600px) {
  .messenger-actions-panel {
    border-radius: 14px;
    margin: 10px 0;
  }

  .messenger-actions-panel__body {
    padding: 16px;
  }

  .messenger-actions-panel__buttons {
    align-items: stretch;
    flex-direction: column;
  }

  .messenger-action-btn,
  .messenger-actions-panel__buttons >>> .v-btn {
    margin: 0 !important;
    width: 100%;
  }

  .messenger-action-btn--danger {
    margin-left: 0 !important;
  }
}

.test {
  background-color: aqua;
}

.field-disable-title {
  color: #9e9e9e;
  font-size: 12px;
}

.field-disable-data {
  color: #9e9e9e;
  font-size: 16px;
}

/* .time-picker input.display-time {
  border: none;
  background-color:pink;
} */
.forn-timepicker {
  border: none;
  font-size: 15px;
  padding: none;
}

.title-order-info-startend {
  font-size: 15px;
  color: grey;
  top: 5px;
  text-align: left;
  margin-top: 1rem;
}

.order-info-startend {
  font-size: 15px;
  /* color: grey; */
  border: 1px solid #d6d6d6;
  padding: 5px 10px;
  margin: 5px 0;
  border-radius: 5px;
  word-wrap: break-word;
  max-height: 92px;
  overflow: auto;
  text-align: left;
}

.title-after-input-data {
  font-size: 12px;
  color: grey;
  top: 5px;
  position: absolute;
}

.hidden-disable {
  overflow: visible;
  padding: 0;
  border: none;
  text-align: center;
  margin-top: 24px;
}

.hidden-disable:after {
  content: ".";
  color: white;
  width: 100%;
  position: absolute;
  top: 29px;
  font-size: 5px;
  background: white;
}

.hidden-disable-addon {
  overflow: visible;
  padding: 0;
  border: none;
  text-align: center;
  margin-top: 18px;
}

.hidden-disable-addon:after {
  content: ".";
  color: white;
  width: 100%;
  position: absolute;
  bottom: -5px;
  font-size: 5px;
  background: white;
}
.dispatch-timeline-item {
  display: flex;
  align-items: center;
  position: relative;
  padding: 6px 0 6px 4px;
}
.dispatch-timeline-toolbar-card {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}
.dispatch-timeline-heading {
  align-items: center;
  display: flex;
  gap: 12px;
  justify-content: space-between;
}
.dispatch-timeline-toolbar-title {
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.02em;
}
.dispatch-retry-glass-btn {
  border: 1px solid rgba(255, 255, 255, 0.72) !important;
  box-shadow: 0 8px 18px rgba(253, 223, 0, 0.38) !important;
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
}
.order-action-surface >>> .v-btn.primary {
  --glass-shadow-color: rgba(253, 223, 0, 0.38);
  --glass-shadow-hover-color: rgba(253, 223, 0, 0.5);
}
.order-action-surface >>> .v-btn.red,
.order-action-surface >>> .v-btn.error {
  --glass-shadow-color: rgba(244, 67, 54, 0.32);
  --glass-shadow-hover-color: rgba(244, 67, 54, 0.44);
}
.order-action-surface >>> .v-btn.orange {
  --glass-shadow-color: rgba(255, 152, 0, 0.34);
  --glass-shadow-hover-color: rgba(255, 152, 0, 0.46);
}
.order-action-surface >>> .v-btn.blue,
.order-action-surface >>> .v-btn.info {
  --glass-shadow-color: rgba(33, 150, 243, 0.3);
  --glass-shadow-hover-color: rgba(33, 150, 243, 0.42);
}
.order-action-surface >>> .v-btn.green,
.order-action-surface >>> .v-btn.success {
  --glass-shadow-color: rgba(76, 175, 80, 0.3);
  --glass-shadow-hover-color: rgba(76, 175, 80, 0.42);
}
.order-action-surface >>> .v-btn.grey {
  --glass-shadow-color: rgba(96, 125, 139, 0.24);
  --glass-shadow-hover-color: rgba(96, 125, 139, 0.34);
}
.order-action-surface
  >>> .v-btn:not(.v-btn--icon):not(.v-btn--floating):not(.v-btn--disabled) {
  border: 1px solid rgba(255, 255, 255, 0.58);
  border-radius: 24px;
  box-shadow: 0 8px 18px var(--glass-shadow-color, rgba(38, 50, 56, 0.18)) !important;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}
.order-action-surface
  >>> .v-btn:not(.v-btn--icon):not(.v-btn--floating):not(
    .v-btn--disabled
  ):hover {
  box-shadow: 0 11px 24px
    var(--glass-shadow-hover-color, rgba(38, 50, 56, 0.24)) !important;
  transform: translateY(-1px);
}
.order-action-surface >>> .v-btn--icon {
  border: 1px solid rgba(255, 255, 255, 0.38);
  box-shadow: 0 6px 14px var(--glass-shadow-color, rgba(38, 50, 56, 0.14)) !important;
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
}
.dispatch-status-text {
  margin-top: 6px;
  color: #616161;
  font-size: 13px;
  font-weight: 600;
}
.dispatch-status-subtext {
  margin-top: 4px;
  color: #757575;
  font-size: 12px;
  line-height: 1.45;
}
.dispatch-timeline-horizontal {
  display: flex;
  align-items: stretch;
  gap: 0;
  margin-top: 12px;
  overflow-x: auto;
}
.dispatch-timeline-horizontal-item {
  display: flex;
  align-items: center;
  flex: 1 1 0;
  min-width: 0;
}
.dispatch-timeline-step {
  opacity: 0;
  transform: translateY(8px);
  animation: dispatch-timeline-reveal 420ms ease forwards;
  animation-delay: var(--dispatch-step-delay, 0ms);
}
.dispatch-timeline-step-active .v-icon {
  animation: dispatch-timeline-pulse 1.8s ease-in-out infinite;
  transform-origin: center;
}
.dispatch-timeline-horizontal-text {
  margin-left: 8px;
  font-weight: 500;
  white-space: nowrap;
}
.dispatch-timeline-horizontal-line {
  flex: 1 1 auto;
  min-width: 24px;
  height: 2px;
  margin: 0 12px;
  background-color: #e0e0e0;
}
.dispatch-timeline-vertical {
  margin-top: 8px;
}
.dispatch-timeline-text {
  margin-left: 8px;
  font-weight: 500;
}
.dispatch-timeline-line {
  position: absolute;
  left: 12px;
  top: 22px;
  height: 18px;
  width: 2px;
  background-color: #e0e0e0;
}
@keyframes dispatch-timeline-reveal {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes dispatch-timeline-pulse {
  0%,
  100% {
    transform: scale(1);
    filter: drop-shadow(0 0 0 rgba(0, 0, 0, 0));
  }
  50% {
    transform: scale(1.12);
    filter: drop-shadow(0 0 6px rgba(253, 223, 0, 0.45));
  }
}
@media (max-width: 600px) {
  .dispatch-timeline-heading {
    align-items: flex-start;
    flex-direction: column;
  }
}
</style>
